import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadAuftragMerkmalListStatus: 'idle',
    loadAuftragMerkmalListError: undefined as any,
    loadAuftragMerkmalListLastArgs: undefined as any,
    loadAuftragMerkmalStatus: 'idle',
    loadAuftragMerkmalError: undefined as any,
    saveAuftragMerkmalStatus: 'idle',
    saveAuftragMerkmalError: undefined as any,
    deleteAuftragMerkmalStatus: 'idle',
    deleteAuftragMerkmalError: undefined as any,

    auftragMerkmalList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadAuftragMerkmalList = createAsyncThunk('auftragMerkmalSlice/loadAuftragMerkmalList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().auftragMerkmalSlice.loadAuftragMerkmalListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisauftmerkmal/?action=gte&MIN_AUFTRAGID=${parentModel.HDR_ID}&MAX_AUFTRAGID=${parentModel.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadAuftragMerkmalListStatus } = getState().auftragMerkmalSlice
        return loadAuftragMerkmalListStatus !== 'pending'
    }
})

export const loadAuftragMerkmal = createAsyncThunk('auftragMerkmalSlice/loadAuftragMerkmal', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisauftmerkmal/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadAuftragMerkmalStatus } = getState().auftragMerkmalSlice
        return loadAuftragMerkmalStatus !== 'pending'
    }
})

export const saveAuftragMerkmal = createAsyncThunk('auftragMerkmalSlice/saveAuftragMerkmal', async ({ auftragMerkmal }: any, { rejectWithValue }: any) => {
    let promises = []
    if (auftragMerkmal?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nurisauftmerkmal/${ auftragMerkmal?.HDR_ID }/`,
            prepareData(auftragMerkmal),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nurisauftmerkmal/`,
            prepareData(auftragMerkmal),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveAuftragMerkmalStatus } = getState().auftragMerkmalSlice
        return saveAuftragMerkmalStatus !== 'pending'
    }
})

export const deleteAuftragMerkmal = createAsyncThunk('auftragMerkmalSlice/deleteAuftragMerkmal', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/nurisauftmerkmal/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteAuftragMerkmalStatus } = getState().auftragMerkmalSlice
        return deleteAuftragMerkmalStatus !== 'pending'
    }
})

const AuftragMerkmalSlice = createSlice({
    name: 'auftragMerkmalSlice',
    initialState,
    reducers: {
        resetloadAuftragMerkmalListError: (state) => {
            state.loadAuftragMerkmalListError = undefined
        },
        resetloadAuftragMerkmal: (state) => {
            state.formItem = undefined
            state.loadAuftragMerkmalError = undefined
        },
        resetloadAuftragMerkmalError: (state) => {
            state.loadAuftragMerkmalError = undefined
        },
        resetsaveAuftragMerkmal: (state) => {
            state.formItem = undefined
            state.saveAuftragMerkmalError = undefined
        },
        resetsaveAuftragMerkmalError: (state) => {
            state.saveAuftragMerkmalError = undefined
        },
        resetdeleteAuftragMerkmalError: (state) => {
            state.deleteAuftragMerkmalError = undefined
        },
        removeFromAuftragMerkmalListById: (state, action) => {
            state.auftragMerkmalList = state.auftragMerkmalList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromAuftragMerkmalListByIds: (state, action) => {
            state.auftragMerkmalList = state.auftragMerkmalList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.auftragMerkmalList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadAuftragMerkmalListStatus = 'preloaded'
            state.loadAuftragMerkmalListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.auftragMerkmalList = []
            state.loadAuftragMerkmalListStatus = 'idle'
            state.loadAuftragMerkmalListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadAuftragMerkmalList.pending, (state) => {
            state.loadAuftragMerkmalListStatus = 'pending'
            state.loadAuftragMerkmalListError = undefined
        })
        builder.addCase(loadAuftragMerkmalList.fulfilled, (state, action) => {
            state.loadAuftragMerkmalListStatus = 'idle'

            if (!action.payload) { return }

            state.loadAuftragMerkmalListLastArgs = action.payload.args

            {
                state.auftragMerkmalList = action.payload.data

            }
        })
        builder.addCase(loadAuftragMerkmalList.rejected, (state, action) => {
            state.loadAuftragMerkmalListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadAuftragMerkmalListError = action.error.message
            } else {
                state.loadAuftragMerkmalListError = action.payload
            }
        })

        builder.addCase(loadAuftragMerkmal.pending, (state) => {
            state.loadAuftragMerkmalStatus = 'pending'
            state.loadAuftragMerkmalError = undefined
        })
        builder.addCase(loadAuftragMerkmal.fulfilled, (state, action) => {
            state.loadAuftragMerkmalStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.auftragMerkmalList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.auftragMerkmalList.push(newItem) }
                else { state.auftragMerkmalList[i] = { ...state.auftragMerkmalList[i], ...newItem } }
            }
        })
        builder.addCase(loadAuftragMerkmal.rejected, (state, action) => {
            state.loadAuftragMerkmalStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadAuftragMerkmalError = action.error.message
            } else {
                state.loadAuftragMerkmalError = action.payload
            }
        })

        builder.addCase(saveAuftragMerkmal.pending, (state) => {
            state.saveAuftragMerkmalStatus = 'pending'
            state.saveAuftragMerkmalError = undefined
        })
        builder.addCase(saveAuftragMerkmal.fulfilled, (state, action) => {
            state.saveAuftragMerkmalStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.auftragMerkmalList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.auftragMerkmalList.push(newItem) }
                else { state.auftragMerkmalList[i] = { ...state.auftragMerkmalList[i], ...newItem } }
            }
        })
        builder.addCase(saveAuftragMerkmal.rejected, (state, action) => {
            state.saveAuftragMerkmalStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveAuftragMerkmalError = action.error.message
            } else {
                state.saveAuftragMerkmalError = action.payload
            }
        })

        builder.addCase(deleteAuftragMerkmal.pending, (state) => {
            state.deleteAuftragMerkmalStatus = 'pending'
            state.deleteAuftragMerkmalError = undefined
        })
        builder.addCase(deleteAuftragMerkmal.fulfilled, (state, action) => {
            state.deleteAuftragMerkmalStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.auftragMerkmalList = state.auftragMerkmalList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.auftragMerkmalList = state.auftragMerkmalList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteAuftragMerkmal.rejected, (state, action) => {
            state.deleteAuftragMerkmalStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteAuftragMerkmalError = action.error.message
            } else {
                state.deleteAuftragMerkmalError = action.payload
            }
        })

    }
})

export const {
    resetloadAuftragMerkmalListError,
    resetloadAuftragMerkmal,
    resetloadAuftragMerkmalError,
    resetsaveAuftragMerkmal,
    resetsaveAuftragMerkmalError,
    resetdeleteAuftragMerkmalError,
    removeFromAuftragMerkmalListById,
    removeFromAuftragMerkmalListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = AuftragMerkmalSlice.actions
export default AuftragMerkmalSlice.reducer
